<div class="task-state-icon" [ngClass]="{'important': important, 'any': any}">
  <sc-icon iconClass="fa-list-check"></sc-icon>
</div>
